var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"copyright",class:{ 'portrait': _vm.isPortrait },attrs:{"src":_vm.$image('copyright.svg'),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }